var map = {
	"./facebook-logo-gray.svg": "b644",
	"./google-logo-gray.svg": "885d",
	"./linkedin-logo-gray.svg": "a973",
	"./snapchat-logo-gray.svg": "1760",
	"./tiktok-logo-gray.svg": "8762",
	"./twitter-logo-gray.svg": "19be"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "94b9";